<template>
  <div
    class="left-1/2 -translate-x-1/2 transform"
    :class="absolute && 'absolute'"
  >
    <div
      class="wrap flex items-center justify-between rounded-full p-2 text-stone-400"
    >
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
type Props = {
  absolute?: boolean;
};

withDefaults(defineProps<Props>(), {
  absolute: false,
});
</script>

<style scoped>
.wrap {
  background-color: rgb(66 66 69 / 70%);
  backdrop-filter: blur(7px);
  -webkit-backdrop-filter: blur(7px);
  box-shadow: inset 0 0 1px rgb(232 232 237 / 30%);
}
</style>
